<script lang="ts" setup>
// Added this to handle removal of utm_* parameters by varnish
// see https://github.com/nuxt/nuxt/issues/23153
await useAsyncData('data',
  async (nuxtApp) => {
    delete nuxtApp?.payload?.path
    return {}
  },
)

const { public: config } = useRuntimeConfig()

const { initCartWatchers } = useCart()
const { fetchStoreData } = useStore()
await fetchStoreData()

const { $t, $getLocale } = useI18n()
const locale = $getLocale()

onMounted(() => {
  initCartWatchers()
})

useSeoMeta({
  // Set title tag
  title: $t('meta.name') as string,
  description: '',
  // Set meta data
  formatDetection: 'telephone=no',
  msapplicationTileColor: '#16002b',
  themeColor: '#ffffff',
})

useHeadSafe({
  htmlAttrs: {
    lang: locale,
  },
  link: [
    { rel: 'icon', type: 'image/svg+xml', href: '/favicon.svg' },
    { rel: 'icon', type: 'image/png', sizes: '96x96', href: '/favicon-32x32.png' },
    { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
    { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' },
    { rel: 'shortcut icon', href: '/favicon.ico' },
    { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
    { rel: 'manifest', href: '/site.webmanifest' },
    { rel: 'preconnect', href: config.xcdnUrl },
  ],
})
</script>

<template>
  <div class="app">
    <NuxtRouteAnnouncer />

    <a
      class="layout__skip-link skip-link"
      href="#main"
    >
      {{ $t('Skip to main content') }}
    </a>

    <AppNotification />

    <NuxtLayout class="app__layout">
      <NuxtPage class="app__template" />
    </NuxtLayout>

    <ThirdpartyLoader :loadtime="7500" />

    <LazyDevtools />
  </div>
</template>

<style>
@import url("~layers/app/assets/css/vars.css");
@import url("~layers/app/assets/css/tokens/colors.css");
@import url("~layers/app/assets/css/base/reset.css");
@import url("~layers/app/assets/css/base/root-and-sectioning.css");
@import url("~layers/app/assets/css/base/forms-and-inputs.css");
@import url("~layers/app/assets/css/base/forms-and-inputs__file.css");
@import url("~layers/app/assets/css/base/forms-and-inputs__color.css");
@import url("~layers/app/assets/css/base/forms-and-inputs__range.css");
@import url("~layers/app/assets/css/base/forms-and-inputs__select.css");
@import url("~layers/app/assets/css/base/forms-and-inputs__checkbox-radio.css");
@import url("~layers/app/assets/css/base/text-content.css");
@import url("~layers/app/assets/css/base/text-content__headings.css");
@import url("~layers/app/assets/css/base/text-content__anchor-button.css");
@import url("~layers/app/assets/css/base/text-content__kbd.css");
@import url("~layers/app/assets/css/base/text-content__ruby.css");
@import url("~layers/app/assets/css/base/multimedia-and-embeds.css");
@import url("~layers/app/assets/css/base/lists.css");
@import url("~layers/app/assets/css/base/tables.css");
@import url("~layers/app/assets/css/base/details-summary.css");
@import url("~layers/app/assets/css/base/dialog-popover-backdrop.css");
@import url("~layers/app/assets/css/base/meter.css");
@import url("~layers/app/assets/css/base/progress.css");

/* @import url("~layers/app/assets/css/keyframes/overflow-detection.css"); */
@import url("~layers/app/assets/css/keyframes/percentage.css");
@import url("~layers/app/assets/css/keyframes/reveal.css");
@import url("~layers/app/assets/css/transitions/slide-down.css");
@import url("~layers/app/assets/css/utilities/utilities.css");
@import url("~layers/app/assets/css/utilities/buttons.css");
@import url("~layers/app/assets/css/utilities/messages.css");
@import url("~layers/app/assets/css/utilities/tables.css");
@import url("~layers/app/assets/css/vue-formkit.css");
@import url("~layers/app/app.css");
</style>
